<template>
  <div class="row">
    <div class="col">
      <div class="card border-light shadow-sm">
        <div class="card-body">
          <table class="table table-borderless mb-0">
            <tbody>
              <tr>
                <th scope="row">Serial Number</th>
                <td>{{ specs.serialNumber }}</td>
              </tr>
              <tr>
                <th scope="row">Gearbox Type</th>
                <td>{{ specs.gearboxType }}</td>
              </tr>
              <tr>
                <th scope="row">Hours of Operation</th>
                <td>{{ specs.hoursOfOperation }} h</td>
              </tr>
              <tr>
                <th scope="row">App Version</th>
                <td>{{ specs.appVersion }}</td>
              </tr>
              <tr>
                <th scope="row" style="vertical-align: middle;">Demo Mode</th>
                <td class="p-0">
                  <mz-demo-toggle></mz-demo-toggle>
                </td>
              </tr>
              <tr>
                <th scope="row" style="vertical-align: middle;">Demo Duration</th>
                <td class="p-0">
                  <mz-demo-duration></mz-demo-duration>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DemoToggle from '@/components/controls/DemoToggle'
import DemoDuration from '@/components/controls/DemoDuration'
import { mapGetters } from 'vuex'

export default {
  name: 'specs',
  computed: {
    ...mapGetters(['specs'])
  },
  components: {
    mzDemoToggle: DemoToggle,
    mzDemoDuration: DemoDuration
  }
}
</script>

<style>
th {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/views/home/Specs.vue